import { useTranslation } from "react-i18next";

/**
 * Compact status badge for agreed overtime on hour rows / dialogs.
 */
export function AgreedOvertimeBadge({ hour, className = "" }) {
  const { t } = useTranslation();
  if (!hour?.agreed_overtime_requested && !hour?.agreed_overtime_confirmed) {
    return null;
  }

  const hours = Number.parseFloat(hour?.agreed_overtime_hours);
  const hoursLabel = Number.isFinite(hours) ? ` ${hours}t` : "";

  if (hour?.agreed_overtime_confirmed) {
    return (
      <span
        className={`inline-flex items-center rounded-full bg-emerald-100 px-2 py-0.5 text-xs font-medium text-emerald-800 ${className}`}
      >
        {t("hours.agreed_overtime.badge_confirmed")}
        {hoursLabel}
      </span>
    );
  }

  return (
    <span
      className={`inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 ${className}`}
    >
      {t("hours.agreed_overtime.badge_pending")}
      {hoursLabel}
    </span>
  );
}

export function isAgreedOvertimePending(hour) {
  return Boolean(hour?.agreed_overtime_requested && !hour?.agreed_overtime_confirmed);
}
